// API Configuration - Uses environment variable, with fallback to dev server
const isDevelopment = import.meta.env.DEV;

// VITE_API_URL must be set in .env for production builds
export const API_URL = import.meta.env.VITE_API_URL || 'http://127.0.0.1:8000';

export default API_URL;
